import { useStaticQuery, graphql } from 'gatsby'

export const getSelectedArticleTitle = title => {
  const { blog, article, video, event } = useStaticQuery(allArticlesQuery)
  const list = [...blog.nodes, ...video.nodes, ...event.nodes]
  const selectedArticle = list.filter(article => article.title === title)
  return selectedArticle
}

const allArticlesQuery = graphql`
  query {
    blog: allStrapiBlog {
      nodes {
        title
        updatedAt
      }
    }
    video: allStrapiVideo {
      nodes {
        title
        updatedAt
      }
    }
    event: allStrapiEvent {
      nodes {
        title
        updatedAt
      }
    }
  }
`
